module.exports = __webpack_public_path__ + "img/Patch1-20170701.4b49f46d.webp";